import React, { useState } from "react"
import styled from "styled-components"
import ReactMapGL, { Marker } from "react-map-gl"
import {
  BodyCopy,
  CallToAction,
  StandardContainer,
  SectionWrapper,
} from "../../common"

const StyledMapBlock = styled(StandardContainer)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  > ${BodyCopy} {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0 0;
    }
    margin-bottom: 2rem;
  }
  > div {
    width: 100%;
  }
  @media ${(props) => props.theme.breakpoints.large} {
    > div {
      width: calc(50% - 1rem);
    }
  }
`

const StyledMarker = styled((props) => <Marker {...props} />)`
  width: 50px;
  height: 50px;
  border-radius: 100px;
  background: ${(props) => props.theme.colors.brandColor};
`

export const MapBlock = ({
  text,
  location,
  link_type,
  link_target,
  page_link,
  link_text,
  anchor_id,
  block_background,
}) => {
  const INITIAL_VIEWPORT = {
    latitude: location?.latitude,
    longitude: location?.longitude,
    zoom: 16,
  }
  const [viewport, setViewport] = useState(INITIAL_VIEWPORT)
  return (
    <SectionWrapper $bgColor={block_background}>
      <StyledMapBlock $wrappedStandard id={anchor_id}>
        <BodyCopy>
          <div dangerouslySetInnerHTML={{ __html: text?.html }} />
          <CallToAction
            type={link_type}
            text={link_text}
            target={link_target}
            page={page_link}
          />
        </BodyCopy>
        <div>
          <ReactMapGL
            width="100%"
            height="350px"
            mapboxApiAccessToken="pk.eyJ1IjoibHVrZS1kb2lnLWJyYXZlIiwiYSI6ImNqdnJmNXlyaTJkeWUzeXFqa2g1NDE1NDMifQ.9gZ0DygX_glVXLY6IsHjpA"
            scrollZoom={false}
            onViewportChange={(newViewport) => setViewport(newViewport)}
            {...viewport}
          >
            <StyledMarker
              latitude={location?.latitude}
              longitude={location?.longitude}
            ></StyledMarker>
          </ReactMapGL>
        </div>
      </StyledMapBlock>
    </SectionWrapper>
  )
}
